exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3lZY8LbffEGpL0FNuYEGsi{display:block;text-align:center}\n", ""]);

// exports
exports.locals = {
	"textAlign": "_3lZY8LbffEGpL0FNuYEGsi"
};